import { type ConditionUpdater, type ICondition, type IFieldOptions } from '../../../common/types';

import CommonConditionFields from './common';
import KeyValueConditionFields from './key-value';
import PriorityConditionFields from './priority';

export interface IConditionProps extends ICondition {
	fields: IFieldOptions[];
	update: ConditionUpdater;
	delete: () => void;
	conditionCount: number;
	isFieldKeyRequired?: boolean;
	isDisabled?: boolean;
	isReadOnly?: boolean;
	autoFocus: boolean;
	isCustomDynamicPropertiesEnabled?: boolean;
	updateCustomDynamicProperties?: (value: string) => void;
}

export const TYPE_MAPPING = {
	string: CommonConditionFields,
	number: CommonConditionFields,
	list: CommonConditionFields,
	keyValue: KeyValueConditionFields,
	boolean: CommonConditionFields,
	priority: PriorityConditionFields,
	map: CommonConditionFields,
	url: CommonConditionFields,
} as const;
